import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Address, PdqUser } from '@pdqdev/pdq-shared/dist/entities';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserManagementService } from '../../../../services/user-management/user-management.service';
import { ColumnSettings, ColumnTypes } from '../../../../storybook/components/table/table.component';
import { TagConfig } from '../../../../storybook/contextual/popovers/tags/tags.component';
import { PopoverService } from '../../../../storybook/services/popover/popover.service';

// export interface ColumnSettings {
//   prop: string;
//   type?: ColumnTypes;
//   hideColumnName?: boolean;
//   width?: number;
//   minWidth?: number;
//   maxWidth?: number;
//   name?: string;
//   sortable?: boolean;
//   searchable?: boolean;
//   sortDirection?: 'DESC' | 'ASC' | undefined;
//   checkboxable?: boolean;
//   headerCheckboxable?: boolean;
//   tooltipText?: string;
// }

const TABLE_COLUMNS = [
  { name: 'Name', prop: 'details', type: ColumnTypes.USERNAME, sortByProp: 'name', clickable: true, truncate: true },
  { name: 'Warehouses', prop: 'locationNames', type: ColumnTypes.TEXT, clickable: true },
  { name: 'Roles', prop: 'rolesTags', type: ColumnTypes.TAGS },
  { name: 'Last login', prop: 'lastLoginDate', type: ColumnTypes.DATE, clickable: true },
  // { name: 'Activation', prop: 'activatedTags', type: ColumnTypes.TAGS, sortable: false },
];
export interface UserTableRow extends PdqUser {
  //activatedTags: TagConfig[];
  details?: { avatar?: string; name?: string; email?: string };
  rolesTags: TagConfig[];
  lastLoginDate?: Date;
  locationNames: string;
}
// const ACTIVATED_USER_TAG = { value: 'Activated', size: 'medium', variant: 'success', border: true };
// const NONACTIVATED_USER_TAG = { value: 'Not activated', size: 'medium', variant: 'danger', border: true };
@Component({
  selector: 'users-table',
  templateUrl: './users-table.component.html',
  styleUrls: ['./users-table.component.scss'],
  standalone: false,
})
export class UsersTableComponent implements OnInit, OnDestroy, OnChanges {
  @Input() shopLocations: Address[];
  @Input() shopSupportsLocations: boolean;
  @Output() onUserClick = new EventEmitter<UserTableRow>();
  rows: UserTableRow[];

  subscriptions: Subscription[] = [];
  activeRowId: string | number;
  columns: ColumnSettings[] = TABLE_COLUMNS;
  currentUser$ = this.usersManagement.selectedUser$;
  private destroy$ = new Subject();
  constructor(
    private popoverService: PopoverService,
    public usersManagement: UserManagementService,
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.shopSupportsLocations) {
      this.initColumns();
    }
  }

  ngOnInit(): void {
    this.initColumns();
    this.initSubscriptions();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }
  private initColumns() {
    this.columns = TABLE_COLUMNS.filter((column) => {
      if (!this.shopSupportsLocations && column.name === 'Warehouses') {
        return false;
      }
      return true;
    });
  }
  private initSubscriptions() {
    this.usersManagement.users$.pipe(takeUntil(this.destroy$)).subscribe((users) => {
      if (users) {
        this.normalizeRows(users);
      }

      this.popoverService.onLoading.next(false);
    });
    this.usersManagement.selectedUser$.pipe(takeUntil(this.destroy$)).subscribe((selectedUser) => {
      this.activeRowId = selectedUser?.id;
    });
  }

  handleRowClick(row: UserTableRow) {
    this.activeRowId = row.id;
    this.onUserClick.emit(row);
  }
  private normalizeRows(users: PdqUser[]) {
    this.rows = users.map((user) => this.normalizeRow(user));
  }

  private normalizeRow(user: PdqUser) {
    //const activatedTag = user.verified ? ACTIVATED_USER_TAG : NONACTIVATED_USER_TAG;
    const rolesTags = user.roles?.map((role) => {
      return { value: role.name, variant: 'quaternary', size: 'small' };
    });

    const locations = user.locations ? user.locations : this.shopLocations;
    const locationNames = locations?.map((location) => this.createLocationName(location))?.join(', ') || '';
    const lastLogin = user.lastLogin ? new Date(user.lastLogin) : undefined;
    const details = { avatar: user.profilePictureUrl, name: user.name, email: user.email };
    const row: UserTableRow = { ...user, rolesTags, details, lastLoginDate: lastLogin, locationNames };
    return row;
  }

  private createLocationName(location: Address) {
    return location.storeName || location.city;
  }
}
